import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { MenuService } from '../menu.service';
import { Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AutenticacionService } from '../autenticacion.service';
import { PaqueteItemComponent } from '../paquete-item/paquete-item.component';
import { SharedService } from '../shared.service';

@Component({
  selector: 'app-combos',
  templateUrl: './combos.component.html',
  styleUrls: ['./combos.component.scss'],
    providers: [PaqueteItemComponent],
})
export class CombosComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();

  clientOnlyRun: boolean = false;
  serverOnlyRun: boolean = false;

  loading: boolean = false;
  loginStatus: boolean = false;

  public _success = new Subject<string>();
  successMessage!: string;
  public _successFavorito = new Subject<string>();
  successFavoritoMessage!: string;

  environment: any;
  combos: any[] = [];
  paquetes: any[] = [];

  banners: any = {
    Combos: '',
    Paquetes: '',
  };

  filtrarCombosConDescuento(combos: any[]): any[] {
    return (combos || []).filter((c) => Number(c?.descuentoKit) > 0);
  }

  constructor(
      private menu: MenuService,
      public data: SharedService,
      private http: HttpClient,
      private auth: AutenticacionService,
      @Inject(PLATFORM_ID) private platformId: Object
    ) {
    this.environment = environment;

    if (isPlatformBrowser(this.platformId)) {
      this.clientOnlyRun = true;
    } else {
      this.serverOnlyRun = true;
    }
  }

  ngOnInit() {
    this._success.pipe(takeUntil(this.destroy$)).subscribe((message) => this.successMessage = message);
    this._success.pipe(takeUntil(this.destroy$), debounceTime(5000)).subscribe(() => this.successMessage = '');

    this._successFavorito.pipe(takeUntil(this.destroy$)).subscribe((message) => this.successFavoritoMessage = message);
    this._successFavorito.pipe(takeUntil(this.destroy$), debounceTime(5000)).subscribe(() => this.successFavoritoMessage = '');

    // subscribing to data on loginStatus
    this.data.currentLogin.pipe(takeUntil(this.destroy$)).subscribe(
      (status) => {
        this.loginStatus = status;
        // Client only code.
        if (this.clientOnlyRun) {
          const $public = this.loginStatus ? '' : 'public/';

          // Obtengo combos de la API
          this.auth.get($public + 'combos/listado')
          .then(($response)  => {
            this.combos = this.filtrarCombosConDescuento($response.response);
          })
          .catch(($error) => {
            this.data.log('getcombos error combos:', $error);
          });

          // Obtengo Paquetes de la API
          this.auth.get($public + 'paquetes/listado')
          .then(($response)  => {
            this.paquetes = $response.response;
          })
          .catch(($error) => {
            this.data.log('getpaquetes error combos:', $error);
          });
        }
      }
    )

    setTimeout(() => {
      this.banners.Combos = this.menu.secImagenesList.Combos;
      this.banners.Paquetes = this.menu.secImagenesList.Paquetes;
    }, 1000);
  }

  ngOnDestroy() {
    this.destroy$.next();
  }

  alertClicked() {
    this.successMessage = '';
    this.data.toggleCarritoShow();
  }

  alertFavoritoClicked() {
    this.successFavoritoMessage = '';
  }
}
